import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const GeolocMairieHeaderDsfr = (props) => {
  const { switchValue = false, handleSwitchValueChange } = props;
  const { language } = useContext(LanguageContext);

  return (
    <div className="fr-toggle">
      <input
        type="checkbox"
        className="fr-toggle__input"
        id="certification-swtich"
        checked={switchValue}
        aria-describedby="switch-type"
        onChange={() => handleSwitchValueChange(!switchValue)}
      />
      <label className="fr-toggle__label" htmlFor="certification-swtich">
        {t[language].geolocalisation.switch_label}
      </label>
    </div>
  );
};

GeolocMairieHeaderDsfr.propTypes = {
  switchValue: PropTypes.bool,
  handleSwitchValueChange: PropTypes.func.isRequired,
};

export default GeolocMairieHeaderDsfr;
